// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3ezZy","addWidgetButton":"Header_addWidgetButton__1AW1l","dashboardTabs":"Header_dashboardTabs__3Pkh6","active":"Header_active__3J01G"};